import { RoleName, UserRoles } from 'api/services';
import flatMap from 'lodash/flatMap';

export const mapUserRoles = (userRoles?: UserRoles): RoleName[] =>
  flatMap(userRoles?.roles, 'name');
